"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _inputModule = _interopRequireDefault(require("./input.module.scss"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Input = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(Input, _PureComponent);

  var _super = _createSuper(Input);

  function Input() {
    (0, _classCallCheck2["default"])(this, Input);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Input, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          id = _this$props.id,
          type = _this$props.type,
          className = _this$props.className,
          name = _this$props.name,
          value = _this$props.value,
          onChange = _this$props.onChange,
          onFocus = _this$props.onFocus,
          onBlur = _this$props.onBlur,
          placeholder = _this$props.placeholder,
          maxLength = _this$props.maxLength,
          autoFocus = _this$props.autoFocus,
          autoComplete = _this$props.autoComplete,
          readOnly = _this$props.readOnly,
          ariaLabel = _this$props.ariaLabel,
          ariaInvalid = _this$props.ariaInvalid,
          ariaDescribedBy = _this$props.ariaDescribedBy,
          disabled = _this$props.disabled,
          required = _this$props.required,
          defaultValue = _this$props.defaultValue,
          extensionProps = _this$props.extensionProps;
      var valueProp = defaultValue !== undefined ? {
        defaultValue: defaultValue
      } : {
        value: value
      };
      return /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
        id: id,
        type: type,
        className: (0, _classnames["default"])(_inputModule["default"]['c-input'], className),
        name: name
      }, valueProp, {
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        placeholder: placeholder,
        maxLength: maxLength,
        autoFocus: autoFocus // eslint-disable-line jsx-a11y/no-autofocus
        ,
        autoComplete: autoComplete,
        readOnly: readOnly,
        "aria-label": ariaLabel,
        "aria-invalid": ariaInvalid,
        "aria-describedby": ariaDescribedBy,
        disabled: disabled,
        required: required,
        ref: function ref(el) {
          _this.input = el;
        }
      }, extensionProps));
    }
  }]);
  return Input;
}(_react.PureComponent);

(0, _defineProperty2["default"])(Input, "propTypes", {
  /** Required: the unique id of the checkbox input */
  id: _propTypes["default"].string.isRequired,

  /** The input element's type */
  type: _propTypes["default"].string,

  /** Custom class name to be applied */
  className: _propTypes["default"].string,

  /** The name of the input element */
  name: _propTypes["default"].string.isRequired,

  /** The value of the input (if applicable) */
  value: _propTypes["default"].string,

  /** Function to be called when a change event is fired by the input */
  onChange: _propTypes["default"].func,

  /** Function to be called when the input accepts focus */
  onFocus: _propTypes["default"].func,

  /** Function to be called when the input loses focus */
  onBlur: _propTypes["default"].func,

  /** Placeholder text to appear if input is empty */
  placeholder: _propTypes["default"].string,

  /** Set maximum number of characters to be accepted */
  maxLength: _propTypes["default"].number,

  /** Focus on this input when the page loads */
  autoFocus: _propTypes["default"].bool,

  /**  */
  autoComplete: _propTypes["default"].string,

  /** Mark the textarea as readonly so it can't be edited */
  readOnly: _propTypes["default"].bool,

  /** Set the aria-label attribute */
  ariaLabel: _propTypes["default"].string,

  /** Set the aria-invalid attribute */
  ariaInvalid: _propTypes["default"].string,

  /** Set the aria-describedby attribute */
  ariaDescribedBy: _propTypes["default"].string,

  /** Disable the textarea element */
  disabled: _propTypes["default"].bool,

  /** Mark the input element as a required field */
  required: _propTypes["default"].bool,
  defaultValue: _propTypes["default"].string,

  /**  */
  extensionProps: _propTypes["default"].objectOf(_propTypes["default"].any)
});
(0, _defineProperty2["default"])(Input, "defaultProps", {
  className: undefined,
  type: 'text',
  //
  value: '',
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  //
  placeholder: undefined,
  maxLength: null,
  autoFocus: false,
  autoComplete: 'on',
  readOnly: false,
  ariaLabel: undefined,
  ariaInvalid: undefined,
  ariaDescribedBy: undefined,
  disabled: false,
  required: false,
  defaultValue: undefined,
  //
  extensionProps: {}
});
var _default = Input;
exports["default"] = _default;